import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import app from './app'
import home from './home'
import header from './header'
import searchBar from './searchBar'
import menu from './menu'
import propiedades from './propiedades'
import meta from './meta'
import contactForm from './contactForm'
import neighborhood from './neighborhood'
import neighborhoodFront from './neighborhoodFront'
import news from './news'
import brokers from './brokers'
import banners from './banners'
import enterprise from './enterprise'
import imi from './imi'
import residential from './residential'
import office from './office'
import retails from './retails'
import industries from './industries'
import hotels from './hotels'
import fields from './fields'
import appraisals from './appraisals'
import subsidiaries from './subsidiaries'
import newsletter from './newsletter'
import alertlj from './alertlj'
import entrepreneurship from './entrepreneurship'
import terrains from './terrains'
import newsletterWidget from './newsletterWidget'
import services from './services'


export default combineReducers({
  alertlj,
  app,
  appraisals,
  banners,
  brokers,
  contactForm,
  enterprise,
  entrepreneurship,
  fields,
  header,
  home,
  hotels,
  imi,
  industries,
  menu,
  meta,
  neighborhood,
  neighborhoodFront,
  news,
  newsletter,
  office,
  propiedades,
  residential,
  retails,
  searchBar,
  subsidiaries,
  terrains,
  newsletterWidget,
  services,
  routing: routerReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js